import { ServiceStatus } from "../models";

export function isRunning(status: ServiceStatus): boolean {
  return (
    status === ServiceStatus.Creating ||
    status === ServiceStatus.Starting ||
    status === ServiceStatus.Started ||
    status === ServiceStatus.BackupStandBy ||
    status === ServiceStatus.InitialLoading ||
    status === ServiceStatus.Stopping
  );
}
